import { RestrictionDto } from './restriction.dto';
import { DanceEventRestrictionsInterface } from '../../..';

export class DanceEventRestrictionsDto implements DanceEventRestrictionsInterface{
  clothingRestriction?: RestrictionDto;
}
